import { BetSettlementType } from '@/constants';
import type { IBetSettlementPageApi } from '@/types/betSettlement';

export class BetSettlementItem {
    public accountLogin: string;
    public accValidPerc: number;
    public balance: string;
    public betCreatedAt: string;
    public createdAt: string;
    public id: number;
    public internalId: string;
    public odds: string;
    public raw: string;
    public ref: string;
    public result: string;
    public siteId: number;
    public stake: string;
    public typeId: BetSettlementType;
    public validBalance: number;

    constructor(data: IBetSettlementPageApi) {
        this.id = data.id;
        this.createdAt = data.created_at;
        this.typeId = data.type_id;
        this.stake = data.stake;
        this.balance = data.balance;
        this.result = data.result;
        this.raw = data.raw;
        this.betCreatedAt = data.bet_created_at;
        this.odds = data.odds;
        this.internalId = data.internal_id;
        this.siteId = data.site_id;
        this.ref = data.ref;
        this.accValidPerc = data.acc_valid_perc;
        this.accountLogin = data.account_login;
        this.validBalance = data.valid_balance;
    }
}
